import { render, staticRenderFns } from "./ApproveCustomization.vue?vue&type=template&id=66431fee&scoped=true"
import script from "./ApproveCustomization.vue?vue&type=script&lang=js"
export * from "./ApproveCustomization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66431fee",
  null
  
)

export default component.exports